import { CalendarClock, Smile } from "lucide-react";
import { featureStrip } from "./HomeData";

export default function FeatureStrip() {
  return (
    <section className="bg-[#06386f] text-white">
      <div className="grid w-full gap-5 px-5 py-6 sm:grid-cols-2 lg:grid-cols-4 lg:px-10 xl:px-[130px]">
        {featureStrip.map((item, index) => (
          <article key={item.title} className="flex items-center gap-4 lg:border-r lg:border-white/50 lg:pr-7 last:border-r-0">
            <div className="grid h-16 w-16 shrink-0 place-items-center rounded-full border border-white">
              {item.icon ? (
                <img src={item.icon} alt="" className="h-8 w-8" />
              ) : index === 3 ? (
                <CalendarClock className="h-8 w-8" />
              ) : (
                <Smile className="h-8 w-8" />
              )}
            </div>
            <div>
              <h3 className="text-[18px] font-bold leading-tight">{item.title}</h3>
              <p className="mt-1 max-w-[220px] text-[13px] leading-relaxed text-white/90">{item.text}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
